import { render, staticRenderFns } from "./ExtrasContainer.vue?vue&type=template&id=716d5658"
import script from "./ExtrasContainer.vue?vue&type=script&lang=ts"
export * from "./ExtrasContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports